import { ApplicationElement, html } from '@effectivastudio/lit-components';
import '@effectivastudio/lit-components/components/timeago/element.js';

import '../button_more/element.js';
import '../profile_avatar/element.js';
import translations from './translations.js';
import style from './style.lit.css';

/**
 * Comment element - accepts an element with comment text as an unnamed slot.
 *
 * @prop userName - Sender's userName
 * @prop userUrl - Sender's profile URL
 * @prop userPicture - URL to Sender's profile picture
 * @prop timestamp - Timestamp when the comment was created
 * @prop hasParent - True if this comment is a reply to another comment
 * @prop likeCount - Number of likes for this comment (defaults to 0)
 * @prop repliesCount - Number of replies to this comment (defaults to 0)
 *
 * @slot default - Slot for body content
 *
 * @cssprop --background - Component background color
 * @cssprop --text-color - Component text color
 * @cssprop --text-important-color - User name color
 * @cssprop --link-hover-color - Like/reply hover color
 * @cssprop --link-active-color - Like/reply active color
 */

export default class Comment extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    userName: { type: String },
    userUrl: { type: String },
    userPicture: { type: String },
    timestamp: { type: Date },
    hasParent: { type: Boolean },
    likeCount: { type: Number },
    repliesCount: { type: Number },
  };

  /** @internal */
  static translations = translations;

  handleLikeClick() {
    alert('TODO: Like handler');
  }

  handleReplyClick() {
    alert('TODO: Reply handler');
  }

  renderLikeButton() {
    return html`
      <button @click=${this.handleLikeClick} class="like">
        ${this.t(`like`, { count: this.likeCount || 0 })}
      </button>
    `;
  }

  renderReplyButton() {
    return html`
      <button @click=${this.handleReplyClick} class="reply">
        ${this.t(`reply`, { count: this.repliesCount || 0 })}
      </button>
    `;
  }

  renderSeparator() {
    return html`<span class="separator">|</span>`;
  }

  render() {
    return html`
      <aside>
        <xs-profile-avatar
          .picture=${this.userPicture}
          layout=${this.hasParent ? 'xxs' : 'xs'}
          hideStatus
          hideName>
          ${this.userName}
        </xs-profile-avatar>
      </aside>
      <main>
        <header>
          <a href=${this.userUrl}>${this.userName}</a>
          <ef-timeago .timestamp=${this.timestamp}></ef-timeago>
        </header>
        <div class="body">
          <slot></slot>
        </div>
        <footer>
          ${this.renderLikeButton()}
          ${!this.hasParent ? this.renderSeparator() : null}
          ${!this.hasParent ? this.renderReplyButton() : null}
          <xs-btn-more></xs-btn-more>
        </footer>
      </main>
    `;
  }
}

Comment.registerTagName('xs-comment');

customElements.get('xs-comment') ||
  customElements.define('xs-comment', Comment);
